/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M413.179 210.109c7.344 0 13.405 5.974 13.405 13.405 0 7.344-5.974 13.435-13.405 13.435H375.76v23.984h37.419c7.344 0 13.405 5.974 13.405 13.435 0 7.43-6.061 13.405-13.405 13.405h-50.941c-7.344 0-13.405-5.974-13.405-13.405V172.69c0-7.344 6.061-13.405 13.405-13.405h50.94c7.345 0 13.406 6.061 13.406 13.405 0 7.46-5.974 13.435-13.405 13.435H375.76v23.984h37.419zm-82.356 64.259c0 5.77-3.73 10.957-9.21 12.706-1.369.495-2.855.699-4.225.699-4.196 0-8.218-1.953-10.753-5.391l-52.107-70.99v62.859c0 7.46-5.974 13.435-13.405 13.435a13.383 13.383 0 01-13.435-13.435v-101.56c0-5.77 3.73-10.87 9.21-12.736 1.369-.466 2.826-.67 4.225-.67 4.196 0 8.218 1.952 10.753 5.391l52.107 70.99V172.69c0-7.344 6.061-13.405 13.405-13.405 7.46 0 13.435 6.061 13.435 13.405v101.678zm-122.427 0a13.37 13.37 0 01-13.405 13.405 13.377 13.377 0 01-13.435-13.405V172.69c0-7.344 5.974-13.405 13.435-13.405 7.344 0 13.405 6.061 13.405 13.405v101.678zm-52.602 13.492H104.97a13.37 13.37 0 01-13.405-13.405V172.69c0-7.344 5.974-13.405 13.405-13.405 7.46 0 13.435 6.061 13.435 13.405v88.33h37.39c7.46 0 13.434 5.975 13.434 13.435 0 7.344-5.974 13.405-13.435 13.405zM255.985 12C114.88 12 0 105.226 0 219.697c0 102.639 91.07 188.725 214.079 204.986 8.335 1.749 19.67 5.479 22.527 12.619 2.535 6.47 1.66 16.67.787 23.139 0 0-2.944 18.01-3.643 21.915-1.166 6.47-5.158 25.266 22.148 13.813 27.423-11.54 147.489-86.873 201.256-148.654C494.252 306.86 512 265.537 512 219.697 512 105.139 397.209 12 255.985 12z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconLineAlt = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconLineAlt.defaultProps = {
  theme,
};
IconLineAlt.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconLineAlt.displayName = 'IconLineAlt';
export { IconLineAlt };
